import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import {TreatmentPlanningService} from '../treatment-planning.service';
import {TreatmentPlanningDataModel} from '../models/treatment-planning-data.model';
import {CreatePatientCaseModel} from '../../../models/caseProcedures/create-patient-case.model';
import {Globals} from '../../../globals';
import {NotesService} from "../../../services/notes.service";
import {TdoNoteQueryModel} from "../../../main-interface/controls/tdo-notes/models/tdo-note-query.model";
import {NoteDataModel} from "../../../models/notes/note-data.model";

@Component({
  standalone: false,
  selector: 'app-treatment-report',
  templateUrl: './treatment-report.component.html',
  styleUrls: ['./treatment-report.component.css']
})
export class TreatmentReportComponent implements OnInit {
  actionTaken: boolean = false;
  hasApprovedPlan: boolean = false;
  isLoading: boolean = false;
  readyOnly: boolean = true;
  latestVersionNumber: number = 1;
  generatingPdf: boolean = false;
  paymentAmount: number = 0;
  treatmentPlanOptions: TreatmentPlanningDataModel[];

  selectedInvoiceIndex: number = 0;
  invoiceArray: any[] = [];
  note: NoteDataModel;

  dataInvoiceItem: any = {
    title: 'Invoice',
    treatmentPlanningId: '',
    titleImage: 'path-to-image',
    patientName: 'Test Patient',
    showPatientName: true,
    billableName: 'Test Patient',
    showBillableName: true,
    payToName: 'Polyviou Dental Corporation',
    payToAddress1: 'PO Box 11299',
    payToAddress2: ' Newport Beach CA 92658',
    billableItems: [
      {
        serviceDate: '11-11-2012',
        serviceName: 'Test Procedure',
        serviceCode: 'D0123',
        servicePrice: '123',
        serviceInsuranceCoverage: '0',
        serviceDiscount: '20', // %,
        serviceEndPrice: '15'
      }
    ],
  };

  enumCoverageCalcTypePercent: string = '00000048-1000-0000-0000-000000000001';
  enumCoverageCalcTypeAmount: string = '00000048-1000-0000-0000-000000000002';

  constructor(
    public dialogRef: MatDialogRef<TreatmentReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private noteService: NotesService,
    private snackBar: MatSnackBar,
    private _tpService: TreatmentPlanningService,
    private globals: Globals
  ) { }

  ngOnInit() {
    this.treatmentPlanOptions = this.data.treatmentPlanOptions;
    this.readyOnly = this.data.readyOnly;
    this.setupInvoiceObject();
  }

  handleOptionChange(index) {
    this.dataInvoiceItem = this.invoiceArray[index];
    const qo = new TdoNoteQueryModel();
    qo.objectId = this.dataInvoiceItem.treatmentPlanningId;
    qo.parentObjectName = 'dataTreatmentPlanning';
    qo.patientId = this.globals.currentPatientId;
    // qo.categoryEnumId = this.categoryEnumId;
    this.noteService.getNotes(qo).subscribe((res) => {
      if (res.length > 0) {
        this.note = res[0];
      }
    });
  }

  setupInvoiceObject() {
    this.invoiceArray = [];
    this.treatmentPlanOptions.forEach((treatmentPlanOption, i) => {

      const dataInvoiceItem = {
        version: this.latestVersionNumber,
        title: 'Treatment Plan',
        name: `Option ${i + 1}`,
        titleImage: 'path-to-image',
        index: i,
        treatmentPlanningId: treatmentPlanOption.TreatmentPlanningID,
        // invoiceId: this.dataPayment.PaymetnID,
        showDiscounts: true,
        approved: true,
        status: 'Approved',
        showInvoice: false,
        // invoiceIsPaid: this.isPaid,
        showImage: false,
        invoiceDate: new Date(),
        // patientName: `${this.dataPatient.dataContact.FirstName} ${this.dataPatient.dataContact.LastName}`,
        showPatientName: true,
        // billableName: `${this.dataPatient.dataContact.FirstName} ${this.dataPatient.dataContact.LastName}`,
        showBillableName: true,
        payToName: 'Polyviou Dental Corporation',
        payToAddress1: 'PO Box 11299',
        payToAddress2: ' Newport Beach CA 92658',
        paymentAmount: this.paymentAmount,
        columns: [
          // { title: 'Service Date', key: 'serviceDate', show: true, pipe: 'date' },
          { title: 'Service', key: 'serviceName', show: true, pipe: 'trim' },
          { title: 'Code', key: 'serviceCode', show: true, pipe: 'none' },
          { title: 'Rate', key: 'servicePrice', show: true, pipe: 'currency' },
          { title: 'Adj. Rate', key: 'servicePriceAdj', show: true, pipe: 'currency' },
          // { title: 'Charged', key: 'serviceCharged', show: true, pipe: 'currency' },
        ],
        billableItems: [],
        totalDue: 0,
      };
      // you must come up with a new adjusted price

      treatmentPlanOption.Procedures.forEach((ledgerItem, i) => {
        const adjustedPrice = this.calculateAdjustedPrice(ledgerItem);

        if (!ledgerItem.isApproved) {
          dataInvoiceItem.approved = false;
        }

        const obj: any = {
          id: i,
          showItem: true,
          serviceDate: new Date(),
          serviceName: ledgerItem.Description,
          serviceCode: ledgerItem.Code,
          servicePrice: ledgerItem.Fee,
          servicePriceAdj: adjustedPrice, // set this at the time of payment?
          discounts: [

          ],
        };
        // this.dataInvoiceItem.totalDue += ledgerItem.dataARTransactionItem.PriceAdjusted;

        // obj.discounts.push(
        //  { showDiscount: true, discountName: 'SMD Discount', discount: ledgerItem.dataARTransactionItem.DATA_COVERAGE, translatedAmount: (obj.servicePrice - obj.servicePriceAdj) }
        // );

        // obj.discounts.push(
        //  { showDiscount: true, discountName: 'Insurance Coverage', discount: '0%', translatedAmount: 0 }
        // );

        dataInvoiceItem.billableItems.push(obj);
      });

      this.calcInvoiceTotals(dataInvoiceItem);
      this.invoiceArray.push(dataInvoiceItem);
    });

    let approvedIndex = this.invoiceArray.findIndex(invoice => {
      return invoice.approved;
    });
    const approvedInvoice = this.invoiceArray.find(invoice => {
      return invoice.approved;
    });

    if (approvedInvoice) {
      this.invoiceArray.filter(invoice => {
        return !invoice.approved;
      }).forEach(invoice => {
        invoice.status = 'Rejected';
        });
      this.selectedInvoiceIndex = approvedIndex;
      this.hasApprovedPlan = true;
    } else {
      approvedIndex = 0;
      this.invoiceArray.forEach(invoice => {
        invoice.status = 'Awaiting Approval';
      });
      this.hasApprovedPlan = false;
    }

    this.handleOptionChange(approvedIndex);
  }

  calcInvoiceTotals(dataInvoiceItem) {
    dataInvoiceItem.totalDue = 0;
    dataInvoiceItem.billableItems.forEach(item => {
      if (item.showItem) {
        dataInvoiceItem.totalDue += item.servicePriceAdj;
      }
    });
  }

  trimName(name: string) {
    return name;
  }

  calculateAdjustedPrice(ledgerItem) {
    const transactionItem = ledgerItem;
    const originalPrice = transactionItem.Fee;

    const insuranceType = transactionItem.enumFeeCoverageCalcTypeId;
    let insuranceAmount = 0;

    if (insuranceType === this.enumCoverageCalcTypeAmount) {
      insuranceAmount = transactionItem.CoverageAmount;
    } else {
      insuranceAmount = (originalPrice * (transactionItem.CoveragePCT / 100));
    }

    if (typeof insuranceAmount === 'undefined' || isNaN(insuranceAmount)) {
      insuranceAmount = 0;
    }

    // adjusted price = (original price - discount) - insurance
    return originalPrice - insuranceAmount;
  }

  generatePDF() {
    // need to split up the form into pages
    // need to limit the width or scroll out so that it fits
    // need to auto scroll to next section

    this.generatingPdf = true;

    setTimeout(_ => {
      html2canvas(document.querySelector('#pdf-content')).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = 210;
        const pageHeight = 295;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        let heightLeft = imgHeight;
        const doc = new jspdf('p', 'mm');
        let position = 10; // give some top padding to first page

        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft >= 0) {
          position += heightLeft - imgHeight; // top padding for other pages
          doc.addPage();
          doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;
        }
        doc.save(`TreatmentPlan.pdf`);

        this.generatingPdf = false;
      });
    }, 2000);
  }

  close() {
    this.dialogRef.close(this.actionTaken);
  }

  createAlertMessage(type: string, message: string, duration: number = 3000) {
    this.snackBar.open(message, type, {
      duration,
      verticalPosition: 'top'
    });
  }
}
